import { FC } from 'react';
import { ApiAddress, EnumBusinessState } from '@Model';
import { DropdownText, defaultIconSize } from '@synqo/frontend-component-library';
import { IconLock } from '@tabler/icons-react';

export const AddressLinkDropdownPreview: FC<ApiAddress> = ({ display_string, business_state }) => {
    return (
        <div className={'flex flex-row items-center space-x-1.5'}>
            {business_state === EnumBusinessState.Locked ? (
                <IconLock className={'shrink-0'} size={defaultIconSize} color="var(--address-lock-icon-color)" />
            ) : undefined}
            <DropdownText content={display_string} />
        </div>
    );
};
